export const AMORTIZATION = 30;
export const START_PERIOD = 1;
export const TYPE = 0;
